<template>
  <v-dialog v-model="dialogActive" width="600">
    <template v-slot:activator="{ on: dialogOn }">
      <v-tooltip top left>
        <template v-slot:activator="{ on: tooltipOn }">
          <v-list-item-content v-on="{ ...dialogOn, ...tooltipOn }" style="cursor:pointer">
            <v-list-item-title>{{ name || 'Quiz' }}</v-list-item-title>
            <v-list-item-subtitle>Got {{ quiz.correct }} / {{ quiz.questions }} Answers Correct</v-list-item-subtitle>
          </v-list-item-content>
        </template>
        <span>Click to view details about this quiz submission</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-toolbar>
        <v-toolbar-title>Quiz Summary:
          <span style="margin: 5px 0 0 1em">{{ name }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="dialogActive = false" icon>
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <v-list dense>
        <v-list-item v-for="({ label, answers, correctAnswer }, index) in questions" :key="'question-' + index">
          <v-list-item-content>
            <v-list-item-title>{{ label }}</v-list-item-title>
            <v-list-item-subtitle>Chosen Answer: {{ typeof (quiz.answers[index]) === 'number' ? answers[quiz.answers[index]].text : '--Not Chosen--' }}</v-list-item-subtitle>
            <v-list-item-subtitle v-if="quiz.answers[index] !== correctAnswer">Correct Answer: {{ answers[correctAnswer].text }}</v-list-item-subtitle>
            <v-list-item-subtitle v-else-if="correctToProceed && typeof (quiz.answers[index]) === 'number'">First Answer: {{ answers[quiz.firstAnswer[index]].text }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon v-if="quiz.answers[index] === correctAnswer" color="success">fas fa-check</v-icon>
            <v-icon v-else-if="quiz.answers[index] == null">fas fa-question</v-icon>
            <v-icon v-else color="error">fas fa-times</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-card-actions>
        <v-btn text @click="dialogActive = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { ref, onMounted } from '@vue/composition-api'
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    quiz: {
      type: Object,
      required: true
    }
  },
  setup (props, { root }) {
    const dialogActive = ref(false)
    const questions = ref([])
    const correctToProceed = ref(false)

    onMounted(() => {
      root.$feathers.service('orientation/block').get(props.id).then((data) => {
        questions.value = data.questions
        correctToProceed.value = data.correctToProceed
      })
    })

    return {
      dialogActive,
      questions,
      correctToProceed
    }
  }
}
</script>
